<script>
export default {
  name: 'Avatar',
  props: {
    username: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 40,
    },
  },
  computed: {
    style() {
      return {
        fontSize: `${Math.floor(this.size / 2.5)}px`,
      };
    },
    // Chatsell: rota 3 colores de marca por contacto (hash del nombre,
    // determinístico para que el mismo contacto siempre tenga el mismo color).
    avatarColorClass() {
      const name = this.username || '';
      // djb2: distribuye mejor que una suma de charcodes (los anagramas no
      // colapsan al mismo color).
      let hash = 0;
      for (let i = 0; i < name.length; i += 1) {
        hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
      }
      return `cs-avatar-${Math.abs(hash) % 3}`;
    },
    userInitial() {
      const parts = this.username.split(/[ -]/);
      let initials = parts.reduce((acc, curr) => acc + curr.charAt(0), '');

      if (initials.length > 2 && initials.search(/[A-Z]/) !== -1) {
        initials = initials.replace(/[a-z]+/g, '');
      }
      initials = initials.substring(0, 2).toUpperCase();

      return initials;
    },
  },
};
</script>

<template>
  <div
    class="avatar-container"
    :class="avatarColorClass"
    :style="style"
    aria-hidden="true"
  >
    <slot>{{ userInitial }}</slot>
  </div>
</template>

<style scoped>
@tailwind components;
@layer components {
  /* Chatsell: 3 colores de marca que se intercalan por contacto */
  .cs-avatar-0 {
    background-image: linear-gradient(to top, #0e7490 0%, #06b6d4 100%);
  }

  .cs-avatar-1 {
    background-image: linear-gradient(to top, #6d28d9 0%, #8b5cf6 100%);
  }

  .cs-avatar-2 {
    background-image: linear-gradient(to top, #0066cc 0%, #0099ff 100%);
  }
}
.avatar-container {
  @apply flex leading-[100%] font-medium items-center justify-center text-center cursor-default text-white;
}
</style>
